import { render, staticRenderFns } from "./OtherParentingMatters.vue?vue&type=template&id=22e4ff82"
import script from "./OtherParentingMatters.vue?vue&type=script&lang=js"
export * from "./OtherParentingMatters.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports